import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { VerificationService, VerificationStepsEnum } from '@sheerid/jslib';

interface Props {
    verificationService: VerificationService;
}

const DriftLinkComponent: React.SFC<Props> = ({ verificationService }) => {
    const { verificationId, currentStep } = verificationService.verificationResponse;

    const insertDocumentScript = (script: string) => {
        const documentScript = document.createElement('script');
        documentScript.innerText = script;
        documentScript.async = true;
        document.body.appendChild(documentScript);
    };

    const addDriftUserAttributes = (userId ?: string, attributes?: object) => {
        let scriptText = '';
        if (typeof userId !== 'undefined') {
            scriptText = `
                var t = window.driftt = window.drift = window.driftt || [];
                drift.identify('${userId}', ${JSON.stringify(attributes)})
            `;
            insertDocumentScript(scriptText);
        } else if (attributes) {
            scriptText = `
                drift.on('ready', function() {
                    drift.api.setUserAttributes(${JSON.stringify(attributes)})
                })
            `;
            insertDocumentScript(scriptText);
        }
    };

    const openDriftChat = () => {
        // @ts-expect-error
        if (window.drift && window.drift.api) {
            // @ts-expect-error
            // interactionId points to The North Face - Medical playbook
            drift.api.startInteraction({ interactionId: 207055 });
        }
    };

    React.useEffect(() => {
        const userId = undefined;
        const attributes = {
            verificationId: !(currentStep === VerificationStepsEnum.collectMedicalProfessionalPersonalInfo) ? verificationId : undefined,
            programId: verificationService.programId,
        };
        addDriftUserAttributes(userId, attributes);
    }, []);


    return (
        <div className="sid-drift-link sid-h-link-like" onClick={() => {
            openDriftChat();
        }}>
            <FormattedHTMLMessage id="needHelp" defaultMessage="Need help?" />
        </div>
    );
};

export { DriftLinkComponent };
